import React, {useContext, useEffect} from "react";
import {useLocation, useNavigate} from "../helpers/routerCompat";
import {AbilityContext} from "../helpers/Can";
import useCurrentOrg from "../helpers/useCurrentOrg";
import {configurableEntityTabKeys} from "../configurable_entities/configurableEntityAccess";
import ConfigurableEntities from "./ConfigurableEntities";

export default function CustomMetadata() {
    return <ConfigurableEntities mode="metadata"/>;
}

function CustomMetadataAlias({defaultHash, allowedHashes}) {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const pathname = location.pathname.replace(/\/(custom-meta-fields|custom-metadata-entities)\/?$/, "/custom-metadata");
        if (pathname === location.pathname) return;
        const requestedHash = location.hash.slice(1);
        const hash = requestedHash && (!allowedHashes || allowedHashes.includes(requestedHash))
            ? requestedHash : defaultHash;
        navigate(`${pathname}${location.search}${hash ? `#${hash}` : ''}`, {replace: true});
    }, [location.pathname, location.search, location.hash, defaultHash, allowedHashes, navigate]);

    return null;
}

export function AssetFieldsAlias() {
    return <CustomMetadataAlias defaultHash="custom-metadata-fields"/>;
}

export function MetadataEntitiesAlias() {
    const currentOrg = useCurrentOrg();
    const ability = useContext(AbilityContext);
    const location = useLocation();
    const urlOrgSlug = location.pathname.match(/^\/([^/]+)\/manage\/custom-metadata-entities\/?$/)?.[1];
    const targetOrgSlug = window.customDomainOrganizationSlug || urlOrgSlug;
    if (!targetOrgSlug || currentOrg?.slug !== targetOrgSlug) return null;
    const allowedHashes = configurableEntityTabKeys({
        metadataMode: true,
        metadataEntitiesEnabled: !!(currentOrg?.configurable_entities_enabled && currentOrg?.metadata_entities_enabled),
        canManageCustomMetaFields: ability.can("manage", "CustomMetaField"),
        canManageMetadataEntityTypes: ability.can("manage", "MetadataEntityType"),
        canManageMetadataEntityImports: ability.can("manage", "MetadataEntityImport")
    });
    const defaultHash = ["metadata-entities", "metadata-entity-fields", "metadata-entity-imports", "custom-metadata-fields"]
        .find(hash => allowedHashes.includes(hash));
    return <CustomMetadataAlias defaultHash={defaultHash} allowedHashes={allowedHashes}/>;
}
